$(function () {
    //$(window).on('scroll', function() {
    //        var scroll = $(this).scrollTop();
    //        console.log(scroll);
    //        if(scroll == 0){
    //            $('.js-slide-bnr').addClass('is-showed');
    //        }else {
    //            $('.js-slide-bnr').removeClass('is-showed');
    //        }        
    //    });

    function slideIn() {
        $('.js-slide-bnr').addClass('is-showed');
    }
    setTimeout(slideIn, 3000);

    $('.js-slide-bnr').addClass('is-showed');

    $('.js-slide-bnr-close').on('click', function () {
        $('.js-slide-bnr').removeClass('is-showed');
        setTimeout(function () {
            $('.js-slide-bnr').remove();
        }, 2000);

    })

    $(window).on('scroll', function () {
        $('.js-slide-bnr').removeClass('is-showed');
    });
});